import React from 'react';
import { Segment } from 'semantic-ui-react';
import { withNamespaces } from 'react-i18next';

const TableHeader = (props) => {
  const { t } = props;
  
  return (
    <Segment basic>{t('my:pos.header.text1')} {t('my:pos.header.text2')}</Segment>
  );
};

export default withNamespaces('my')(TableHeader);



// WEBPACK FOOTER //
// ./src/private/user/components/PurchaseOrders/Header.js